import {
	GdsService_OrderAdditionalServiceGdsServiceVip_Fragment,
	GdsServiceVipSubType,
	OrderAdditionalServiceGdsServiceServiceType,
	OrderAdditionalServicesFragment
} from '@websky/graphql';

export const isSeatChangeChargeGdsService = (
	service: OrderAdditionalServicesFragment['gdsServices']['services'][number]
): boolean =>
	service?.type === OrderAdditionalServiceGdsServiceServiceType.Vip &&
	(service as GdsService_OrderAdditionalServiceGdsServiceVip_Fragment).subType ===
		GdsServiceVipSubType.SeatChangeCharge;
